import React from 'react'
import Link from 'gatsby-link'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import './newslettersignup.scss'

class NewsletterSignup extends React.Component {
  constructor() {
    super()
    this.state = {
      email: ``,
    }
  }
  // Update state each time user edits their email address
  _handleEmailChange = e => {
    this.setState({ email: e.target.value })
  }

  // Post to MC server & handle its response
  _postEmailToMailchimp = (email, attributes) => {
    addToMailchimp(email, attributes)
    .then(result => {
        // Mailchimp always returns a 200 response
        // So we check the result for MC errors & failures
        if (result.result !== `success`) {
          this.setState({
            status: `error`,
            msg: result.msg,
          })
        } else {
          // Email address succesfully subcribed to Mailchimp
          this.setState({
            status: `success`,
            msg: result.msg,
          })
        }
      })
    .catch(err => {
        // Network failures, timeouts, etc
        this.setState({
          status: `error`,
          msg: err,
        })
      })
  }
  _handleFormSubmit = e => {
    if(document.getElementById("newsletter-input").checkValidity() == true) {
      e.preventDefault()
      e.stopPropagation()
      this.setState(
      {
        status: `sending`,
        msg: null,
      },
      // setState callback (subscribe email to MC)
      this._postEmailToMailchimp(this.state.email, {
        pathname: document.location.pathname,
      })
      )
    }
  }
  render() {
    const { signupMessage, confirmMessage } = this.props
    return (
      <div className="newsletter-wrapper">
      {this.state.status === `success` ? (<div className="newsletter-form-response">{confirmMessage}</div>) :
      (
        <div>
        <form id="email-capture" method="post">
        <label htmlFor="newsletter-input">{signupMessage}</label>
        <input id="newsletter-input" type="email" name="email" placeholder="you@email.com" onChange={this._handleEmailChange} required />
        <input type="submit" className="btn btn-primary" onClick={this._handleFormSubmit} />
        {this.state.status === `error` && (
          <div className="newsletter-form-response" dangerouslySetInnerHTML={{ __html: this.state.msg }} />
          )}
        </form>
        </div>
        )}
      </div>
      )
  }
}

NewsletterSignup.defaultProps = {
  signupMessage: "Enter your email to get started",
  confirmMessage: "Dope. You're in there. You'll be the first to know when Curveball launches."
}

export default NewsletterSignup



// WEBPACK FOOTER //
// ./src/components/landing/newslettersignup/newsletterSignup.js